'use client'
import MyImage from '@/shared/components/myImage'
import { getImgURL } from '@/shared/utils'

function Card({ cardData, title }: any) {
  return (
    <div className="grid grid-cols-3 py-4 md:py-3 border-t border-tabBorder items-center">
      <div>
        <div className="flex items-center gap-2 md:gap-3.5">
          {cardData?.oMatch?.oTeamScoreA?.oTeam?.oImg?.sUrl ? (
            <MyImage
              className="w-6 h-6 md:w-7 md:h-7 object-cover rounded-full"
              width={28}
              height={28}
              src={getImgURL(cardData?.oMatch?.oTeamScoreA?.oTeam?.oImg?.sUrl)}
              alt="flag"
            />
          ) : null}
          <div>
            <p className="text-sm md:text-base text-textOffWhite">
              {cardData?.oMatch?.oTeamScoreA?.oTeam?.sAbbr}
            </p>
            <p className="text-xs md:text-sm font-bold text-textOffWhit md:block hidden">
              {cardData?.oMatch?.oTeamScoreA?.sScores || '-'}{' '}
              <span className="text-textDselected font-medium ml-0.5">
                {cardData?.oMatch?.oTeamScoreA?.sOvers
                  ? `(${cardData?.oMatch?.oTeamScoreA?.sOvers} Ov)`
                  : null}
              </span>
            </p>
          </div>
        </div>
        <p className="mt-2 md:mt-0 text-xs md:text-sm font-bold text-textOffWhite block md:hidden">
          {cardData?.oMatch?.oTeamScoreA?.sScores || '-'}{' '}
          <span className="text-textDselected font-medium ml-0.5">
            {cardData?.oMatch?.oTeamScoreB?.sOvers
              ? `(${cardData?.oMatch?.oTeamScoreB?.sOvers} Ov)`
              : null}
          </span>
        </p>
      </div>
      <div className="text-center">
        <p className="text-sm text-textOffWhite font-medium">{title}</p>
        <span className="text-xxs md:text-sm text-subSectionText font-medium mt-1 md:mt-1.5">
          {cardData?.oMatch?.sResult}
        </span>
      </div>
      <div className="text-right">
        <div className="flex items-center justify-end text-right gap-2 md:gap-3.5">
          <div>
            <p className="text-sm md:text-base text-textOffWhite">
              {cardData?.oMatch?.oTeamScoreB?.oTeam?.sAbbr}
            </p>
            <p className="text-xs md:text-sm font-bold text-textOffWhit md:block hidden">
              {cardData?.oMatch?.oTeamScoreB?.sScores || '-'}
              <span className="text-textDselected font-medium ml-0.5">
                {cardData?.oMatch?.oTeamScoreB?.sOvers
                  ? `(${cardData?.oMatch?.oTeamScoreB?.sOvers} Ov)`
                  : null}
              </span>
            </p>
          </div>
          {cardData?.oMatch?.oTeamScoreB?.oTeam?.oImg?.sUrl ? (
            <MyImage
              className="w-6 h-6 md:w-7 md:h-7 object-cover rounded-full"
              width={28}
              height={28}
              src={getImgURL(cardData?.oMatch?.oTeamScoreB?.oTeam?.oImg?.sUrl)}
              alt="flag"
            />
          ) : null}
        </div>
        <p className="mt-2 md:mt-0 text-xs md:text-sm font-bold text-textOffWhite block md:hidden">
          {cardData?.oMatch?.oTeamScoreB?.sScores || '-'}{' '}
          <span className="text-textDselected font-medium ml-0.5">
            {cardData?.oMatch?.oTeamScoreB?.sOvers
              ? `(${cardData?.oMatch?.oTeamScoreB?.sOvers} Ov)`
              : null}
          </span>
        </p>
      </div>
    </div>
  )
}

export default Card
